import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'

import { CardTimePeriodFilterOptions } from '../types/profile-card.types'
interface LearningStatsFilter {
  timeFilter: string
  productCategoryFilter: string
}

interface InitialState {
  showNicknameOverlay: boolean
  learningStatsFilter: LearningStatsFilter
  rewardsStatsFilter: string
  productCardTimeFilter: string
  productCardFilterOptions: string[]
}

const profileCardFilterInitialValue = CardTimePeriodFilterOptions.ALL_TIME
const productCardFilterInitialValue = CardTimePeriodFilterOptions.LAST_30_DAYS

const initialState: InitialState = {
  showNicknameOverlay: false,
  learningStatsFilter: { timeFilter: profileCardFilterInitialValue, productCategoryFilter: 'all' },
  rewardsStatsFilter: profileCardFilterInitialValue,
  productCardTimeFilter: productCardFilterInitialValue,
  productCardFilterOptions: [],
}

const slice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    setShowNicknameOverlay: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showNicknameOverlay: action.payload,
    }),
    setLearningTimeFilter: (state, action: PayloadAction<string>) => ({
      ...state,
      learningStatsFilter: {
        ...state.learningStatsFilter,
        timeFilter: action.payload,
      },
    }),
    setLearningProductCategoryFilter: (state, action: PayloadAction<string>) => ({
      ...state,
      learningStatsFilter: {
        ...state.learningStatsFilter,
        productCategoryFilter: action.payload,
      },
    }),
    setRewardsTimeFilter: (state, action: PayloadAction<string>) => ({
      ...state,
      rewardsStatsFilter: action.payload,
    }),
    setProductCardsTimeFilter: (state, action: PayloadAction<string>) => ({
      ...state,
      productCardTimeFilter: action.payload,
    }),
    setProductCardFilterOptions: (state, action: PayloadAction<string[]>) => ({
      ...state,
      productCardFilterOptions: action.payload,
    }),
  },
})

export const selectShowNicknameOverlay = (state: RootState): boolean => {
  return state.statistics.showNicknameOverlay
}

export const selectLearningStatsFilter = (state: RootState): LearningStatsFilter => {
  return state.statistics.learningStatsFilter
}

export const selectRewardsStatsFilter = (state: RootState): string => {
  return state.statistics.rewardsStatsFilter
}

export const selectIsRewardsFilterSetToAllTime = (state: RootState): boolean => {
  return state.statistics.rewardsStatsFilter === CardTimePeriodFilterOptions.ALL_TIME
}

export const selectProductCardTimeFilter = (state: RootState): string => {
  return state.statistics.productCardTimeFilter
}

export const selectIsProductCardTimeFilterSetToAllTime = (state: RootState): boolean => {
  return state.statistics.productCardTimeFilter === CardTimePeriodFilterOptions.ALL_TIME
}

export const selectProductCardFilterOptions = (state: RootState): string[] => {
  return state.statistics.productCardFilterOptions
}

export const {
  setShowNicknameOverlay,
  setLearningTimeFilter,
  setRewardsTimeFilter,
  setProductCardsTimeFilter,
  setLearningProductCategoryFilter,
  setProductCardFilterOptions,
} = slice.actions

export default slice.reducer
